import { FC, PropsWithChildren } from 'react'
import Link from 'next/link'
import styles from './index.module.scss'
import { Avatar } from '../../atoms/Avatar'
import { sanitizeUrl } from '../../../utils'

type Props = {
  src: string
  alt: string
  href?: string
}

export const CompanyPanel: FC<PropsWithChildren<Props>> = ({ children, src, alt, href = '' }) => {
  if (href) {
    return (
      <Link href={sanitizeUrl(href)}>
        <a className={styles.container}>
          <div className={styles.thumb}>
            <Avatar src={src} alt={alt} styleType='circle' />
          </div>
          <div className={styles.content}>{children}</div>
        </a>
      </Link>
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.thumb}>
        <Avatar src={src} alt={alt} styleType='circle' />
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  )
}
